
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 140 140","xmlns":"http://www.w3.org/2000/svg","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"}},[_c('path',{attrs:{"d":"M23.251 0.748L0.751 0.748","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M23.251 23.248L0.751 23.248","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.001 14.248L12.001 23.248","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M12.001 0.748L12.001 9.748","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15.751 17.998L12.001 14.248 8.251 17.998","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M15.751 5.998L12.001 9.748 8.251 5.998","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])
          )
        }
      }
    